<!--
component: MapPane,ListKamiResult
author: Okada
description: 検索結果画面
-->
<template>
  <body>
    <section class="list">
      <v-container fluid class="pt-0 px-0">
        <div class="head-message">{{ headMessage }}</div>

          <v-card class="pb-3">
            <v-card-title class="pt-2">
              <v-row>
                <v-col class="d-flex align-center pb-0" :style="{'font-size': ($vuetify.breakpoint.name == ('xs' || 'sm') ? '0.90rem' : '1.25rem')}">
                  {{ '検索条件に一致した結果が' + this.$store.state.daicho.length + '件見つかりました。' }}
                </v-col>
                <!--
                <v-col>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="検索"
                    @keyup="searchMod()"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-col>
                -->
              </v-row>
            </v-card-title>

            <!-- スプレッドシート出力 -->
            <div>
              <ListKamiResult  ref="listKamiResultRef" @call-parent-method="setPrintMode"/>
            </div>

            <!-- メニュー -->
            <div class="button-container">
              <button class="action-button" @click="brief" :disabled="!enableImage">
                概要書表示
              </button>
              <button class="action-button" @click="input" :disabled="!enableInput">
                入力画面
              </button>
              <button class="action-button" @click="goto_print" :disabled="!enablePrint">
                証明書印刷
              </button>
              <button class="action-button" @click="download_csv">
                CSV出力
              </button>
            </div>
          </v-card>
        <br/>

      <!-- 閲覧モード時 -->
<!--
      <div class="button-container">
        <button class="action-button" @click="brief">
          概要書表示
        </button>
        <button class="action-button" @click="print">
          証明書印刷
        </button>
        <button class="action-button" @click="csv">
          CSV出力
        </button>
        <button class="action-button">
          閉じる
        </button>
      </div>  
-->
    
        <Dialog error :open="authDialog" :ok="()=>authDialog=false" :to="'/'"
          title="ユーザー認証" body="ユーザー認証に失敗しました。ログインし直して下さい。"/>
      </v-container>
    </section>
  </body>
</template>

<script>
//import MapComponent from '../components/Map.vue'
import { apiUrl, dbglog, gaiyoURL, /*elvUrl,*/ plotUrl, plotUrlAlt, daichoIMG } from '../common/utils'
import constants from '../common/constants'
import { callGetApi } from '../common/apiAccess'
import Dialog from '../components/Dialog.vue'
import ListKamiResult from '../components/ListKamiResult.vue'

export default {
  data () {
    return {
      columns: ['確定', '確認済', 'コメント', '物件種別', '取止・取下', '確定申請番号', '所在地', '建築主住所', '建築主氏名', '主用途', '構造', '工事種別', '地上階数', '地下階数'],
      data: [
        { id: 1, 確定: 'データ1-1', 確認済: 'データ1-1', コメント: 'データ1-2', 物件種別: 'データ1-3', "取止・取下": 'データ1-4', 確定申請番号: 'データ1-5', 所在地: 'データ1-6', 建築主住所: 'データ1-7', 建築主氏名: 'データ1-8', 主用途: 'データ1-9', 構造: 'データ1-10', 工事種別: 'データ1-11', 地上階数: 'データ1-12', 地下階数: 'データ1-13' },
        { id: 2, 確定: 'データ2-1', 確認済: 'データ1-1', コメント: 'データ2-2', 物件種別: 'データ2-3', "取止・取下": 'データ2-4', 確定申請番号: 'データ2-5', 所在地: 'データ2-6', 建築主住所: 'データ2-7', 建築主氏名: 'データ2-8', 主用途: 'データ2-9', 構造: 'データ2-10', 工事種別: 'データ2-11', 地上階数: 'データ2-12', 地下階数: 'データ2-13' },
        { id: 1, 確定: 'データ1-1', 確認済: 'データ1-1', コメント: 'データ1-2', 物件種別: 'データ1-3', "取止・取下": 'データ1-4', 確定申請番号: 'データ1-5', 所在地: 'データ1-6', 建築主住所: 'データ1-7', 建築主氏名: 'データ1-8', 主用途: 'データ1-9', 構造: 'データ1-10', 工事種別: 'データ1-11', 地上階数: 'データ1-12', 地下階数: 'データ1-13' },
        { id: 2, 確定: 'データ2-1', 確認済: 'データ1-1', コメント: 'データ2-2', 物件種別: 'データ2-3', "取止・取下": 'データ2-4', 確定申請番号: 'データ2-5', 所在地: 'データ2-6', 建築主住所: 'データ2-7', 建築主氏名: 'データ2-8', 主用途: 'データ2-9', 構造: 'データ2-10', 工事種別: 'データ2-11', 地上階数: 'データ2-12', 地下階数: 'データ2-13' },
        { id: 1, 確定: 'データ1-1', 確認済: 'データ1-1', コメント: 'データ1-2', 物件種別: 'データ1-3', "取止・取下": 'データ1-4', 確定申請番号: 'データ1-5', 所在地: 'データ1-6', 建築主住所: 'データ1-7', 建築主氏名: 'データ1-8', 主用途: 'データ1-9', 構造: 'データ1-10', 工事種別: 'データ1-11', 地上階数: 'データ1-12', 地下階数: 'データ1-13' },
        { id: 2, 確定: 'データ2-1', 確認済: 'データ1-1', コメント: 'データ2-2', 物件種別: 'データ2-3', "取止・取下": 'データ2-4', 確定申請番号: 'データ2-5', 所在地: 'データ2-6', 建築主住所: 'データ2-7', 建築主氏名: 'データ2-8', 主用途: 'データ2-9', 構造: 'データ2-10', 工事種別: 'データ2-11', 地上階数: 'データ2-12', 地下階数: 'データ2-13' },
        // 他の行も同様に追加
      ],
      scalevisible: false,
      existsGaiyo: false,
      plotUrl: '',
      plotUrlAlt: '',
      plotDef: null,
      plotDefAlt: null,
      sheetUrl: '',
      nendoList: [],
      bgmapList: [],
      queryingSheet: false,
      nendoCols: 12,
      nendoXlCols: 6,
      textClass: 'text-h6',
      targetPlotData: this.targetPlot,
      selectedLayer: '',
      // swipe用変数
      position: 0,
      startX: 0,
      moveX: 0,
      width: 0,
      authDialog: false,
      enablePrint: false,
      enableImage: false,
      enableInput: false,
    }
  },
  components: {
//    MapComponent,
    ListKamiResult,
    Dialog,
  },
  props: {
    zoom: {
      type: Number,
      default: 18,
    },
    targetPlot: {
      type: Object,
      default: null,
    },
  },
  created () {
    this.plotUrl = plotUrl();
    this.plotUrlAlt = plotUrlAlt();
    this.plotDef = constants.tileDef[this.mode];
    if (this.mode == 5) {
      this.plotDefAlt = constants.tileDef[6];
    }
    dbglog('MapPane:' + this.plotDef);
    if (this.sheetVisible) {
      if (this.mode == 1) {
        this.sheetUrl = this.$store.state.mapOrigin + constants.tileDef[8].url;
      }
      else if (this.mode == 5) {
        this.sheetUrl = this.$store.state.mapOrigin + constants.tileDef[9].url;
      }
    }
    if (this.mode == 7) {
      ///*
      this.bgmapList = [
        this.$store.state.mapOrigin + constants.tileDef[10].url,
        this.$store.state.mapOrigin + constants.tileDef[11].url,
      ];
      //*/
      /*
      this.bgmapList = [];
      if (this.$store.state.seibiSokushinVisible) {
        this.bgmapList.push(this.$store.state.mapOrigin + constants.tileDef[10].url);
      }
      if (this.$store.state.douroShubetsuVisible) {
        this.bgmapList.push(this.$store.state.mapOrigin + constants.tileDef[11].url);
      }
      */
    }
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }
    this.$store.commit('setCurrentPage', 5);
		this.message = '';
    //選択されているプロットの番号が保存されている場合
    if (this.selectedNo) {
      this.searchGaiyo(this.selectedNo, (data) => {
        this.existsGaiyo = (data && data.length);
      });
    }
    this.printing = false;
    //this.targetPlotData = this.targetPlot; //ここでは遅い
    //test
    //console.log(this.targetPlot);
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    headMessage () {
			return "検索結果";
		},
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val); }
    },
    browsable () {
      return this.isSelected && this.existsGaiyo;
    },
    features: {
      get() { return this.$store.state.features; },
      set(val) { this.$store.commit('setFeatures',val); }
    },
    sheets: {
      get() { return this.$store.state.sheets; }
    },
    mode () {
      return this.$store.state.mode;
    },
    authority () {
      //return this.$store.state.authority;
      return this.$store.state.userInfo.authority;
    },
    sheetVisible () {
      //return (this.authority >= 1) && (this.mode == 1 || this.mode == 5);
      // authority=4 は住所検索と番号検索のみ（仮）
      return (this.authority >= 1 && this.authority != 4) && (this.mode == 1 || this.mode == 5);
    },
    douroShubetsuVisible: {
      get() {
        return this.$store.state.douroShubetsuVisible;
      },
      set(val) {
        this.$router.commit('setDouroShubetsuVisible', val);
      }
    },
    gaiyoId () {
      return this.$store.state.gaiyoId;
    },
    gaiyo () {
      return this.$store.state.gaiyoData;
    },
    selectedNo: {
      get() { return this.$store.state.selectedNo; },
      set(val) { this.$store.commit('setSelectedNo', val); }
    },
    selectedId: {
      get() { return this.$store.state.selectedId; },
      set(val) { this.$store.commit('setSelectedId', val); }
    },
    gaiyoList() {
      return this.$store.state.gaiyoList;
    },
    daichoList() {
      return this.$store.state.daicho;
    },
    centerx() {
      return this.$store.state.centerx;
    },
    centery() {
      return this.$store.state.centery;
    },
    selectedPlotTitle() {
      let title = this.plotDef.title;
      if (this.plotDefAlt)
        title += '・' + this.plotDefAlt.title;
      return title;
    },
    browseButtonTitle() {
      if (this.mode == 1) {
        return '概要書を閲覧';
      }
      else if (this.mode == 2) {
        return '昇降機台帳を閲覧';
      }
      else if (this.mode == 3) {
        return '定期報告概要書を閲覧';
      }
      else if (this.mode == 5) {
        if (this.selectedLayer == 'vectorLayer')
          return '開発登録簿を閲覧';
        else if (this.selectedLayer == 'vectorLayerAlt')
          return '造成計画平面図を閲覧';
        else
          return '閲覧';
      }
      else {
        return '閲覧';
      }
    },
    isSelected() {
      return this.selectedNo !== undefined && this.selectedNo !== null
          && this.selectedNo != '';
    },
    wardCode() {
      return this.$store.state.wardCode;
    },
    wardName() {
      return this.$store.state.wardName;
    },
    townCode() {
      return this.$store.state.townCode;
    },
    townName() {
      return this.$store.state.townName;
    },
    oyaban() {
      return this.$store.state.oyaban;
    },
    edaban() {
      return this.$store.state.edaban;
    },
    bottomSheet() {
      return ((this.$store.state.features.length > 0) && (this.$vuetify.breakpoint.name == 'xs'));
    }
  },
  watch: {
    features (newValue, oldValue) {
      dbglog(`MapPane: watch.features(${newValue},${oldValue})`, 2);
      if (newValue != null) {
        if (newValue.length == 0 || newValue.length > 1) {
          this.selectedId = '';
          this.selectedNo = '';
          this.selectedLayer = '';
        }
        else if (newValue.length == 1) {
          this.selectRow(newValue[0]);
        }
      }
    },
    sheets (newValue, oldValue) {
      if ((newValue != oldValue) && !this.queryingSheet) {
        const ku = this.wardCode - 14100;
        let sheets = '';
        for (let i = 0; i < newValue.length; i++) {
          sheets += (sheets.length > 0 ? ',' : '') + newValue[i].indexId;
        }
        let url = '';
        if (this.mode == 1) {
          url = apiUrl('KenkakuPlotIndexNendo') + `?ku=${ku}&sheets=${sheets}`;
        }
        else if (this.mode == 5) {
          url = apiUrl('KaihatsuPlotIndexNendo') + `?ku=${ku}&sheets=${sheets}`;
        }
        else {
          return;
        }
        this.queryingSheet = true;
        callGetApi(url, (data) => {
          this.nendoList = [];
          if (data.length) {
            if (data.length > 10) {
              this.nendoCols = 6;
              this.nendoXlCols = 4;
              this.textClass = 'text-h7';
            }
            else {
              this.nendoCols = 12;
              this.nendoXlCols = 6;
              this.textClass = 'text-h6';
            }
            for (let i = 0; i < data.length; i++) {
              for (let j = 0; j < newValue.length; j++) {
                if (data[i].id == newValue[j].indexId) {
                  this.nendoList.push({
                    id: data[i].id,
                    name: data[i].name,
                    pageNo: newValue[j].pageNo,
                    branch: newValue[j].branch
                  });
                  break;
                }
              }
            }
          }
          this.queryingSheet = false;
        });
      }
    },
  },
  methods: {
		makeImagePostData(item) {
			console.log(item);
			var postData = {};
//			var daicho_search = this.$store.state.daichoSearch;

			//postData.uke_kubun = uke_kubun;
			//postData.id = item.id;
			postData.uke_day = item.uke_day;
//			postData.gengo = getWarekiCode(daicho_search.gengo);
//			postData.nen = daicho_search.nen;
//			postData.nen_kubun = daicho_search.nen_kubun;
//			postData.gyosei_kubun = getWardCode(daicho_search.gyosei_kubun);
//			postData.bango = daicho_search.bango;
//			postData.branch = daicho_search.branch;

			postData.gengo = item.gengo;
			postData.nen = item.nen;
			postData.nen_kubun = item.nen_kubun;
			postData.gyosei_kubun = item.gyosei_kubun;
			postData.bango = item.bango;
			postData.branch = item.branch;

			return (postData);
		},
		checkImageExists(data) {
			var url = "";
			var folder = data.folder;
			var file_name = data.file_name.replace(".tif", '.png');

			console.log('####### checkImageExists');
			if(data.uke_kubun == 5){
				folder = folder.replace(/\\/g, "/");
				console.log(folder);
				console.log(file_name);
				url = this.$store.state.daichoOrigin + `${encodeURIComponent(folder)}/${encodeURIComponent(file_name)}`;
			} else {
				console.log(folder);
				console.log(file_name);
				url = this.$store.state.mapOrigin + `daicho/${encodeURIComponent(folder)}/${encodeURIComponent(file_name)}`;
			}

			var http = new XMLHttpRequest();
			http.open('HEAD', url, false); // 同期的なリクエストを行う
			http.send();
			//return http.status === 200 && http.getResponseHeader('Content-Type').indexOf('image') !== -1;
			return http.status === 200;
		},
		getImageData(daicho_item) {
      this.enableImage = false;

			// 画像表示
			var value = this.makeImagePostData(daicho_item);
			console.log(value);

			var url = daichoIMG() + `/Search`;
			fetch(url, {
				mode: 'cors',
//				method: 'GET',
				method: 'POST',
				headers: {
					'Authorization': 'Bearer ' + this.token,
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(value)
			})
				.then((response) => {
					dbglog(response);
					if (response.ok) {
						return response.json();
					} else {
						return response.status;
					}
				})
				.then((data) => {
					dbglog(data);
					console.log(data);
					for (var i = 0; i < data.length; i++) {
						if(data[i].uke_kubun == 5){
							var copy_obj = null;
							data[i].file_name = data[i].file_name.replace('.tif', '-0.png');
							var orig_copy_obj = Object.assign({}, data[i]);
							if(this.checkImageExists(data[i])) {
                this.enableImage = true;
							}

							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-1.png');
							if(this.checkImageExists(copy_obj)) {
                this.enableImage = true;
							}
							
							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-2.png');
							if(this.checkImageExists(copy_obj)) {
                this.enableImage = true;
							}
							
							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-3.png');
							if(this.checkImageExists(copy_obj)) {
                this.enableImage = true;
							}
							
							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-4.png');
							if(this.checkImageExists(copy_obj)) {
                this.enableImage = true;
							}
							
							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-5.png');
							if(this.checkImageExists(copy_obj)) {
                this.enableImage = true;
							}
							break;
						}
					}
				})
				.catch((err) => {
					dbglog(`Address.vue.searchChiban(): ${err}`);

				});
		},
    setPrintMode() {
			var daicho_list = this.$store.state.daicho;
			var daicho_index = this.$store.state.seldaichoIndex;
			//			var daicho_item = this.$store.state.seldaicho;
			var daicho_item = daicho_list[daicho_index];

      this.getImageData(daicho_item);
      
      if ((daicho_item.stop_sybt == null || daicho_item.stop_sybt == 0) && (daicho_item.flg_kakutei == 1)) {
        //this.enableImage = true;
        this.enablePrint = true;
      } else {
        //this.enableImage = false;
        this.enablePrint = false;
      }
      this.enableInput = true;
    },
    /*
    setPrintMode() {
			var daicho_list = this.$store.state.daicho;
			var daicho_index = this.$store.state.seldaichoIndex;

			//			var daicho_item = this.$store.state.seldaicho;
			var daicho_item = daicho_list[daicho_index];
      if((daicho_item.stop_sybt == null)|| (daicho_item.stop_sybt == 0)) {
        this.enablePrint = true;
      } else {
        this.enablePrint = false;
      }
    }, 
    */
    brief() {
      this.$store.commit('setSearchMode', 0);
      this.$router.push('kamiresultbrief');
    }, 
    input() {
      this.$store.commit('setSearchMode', 0);
      this.$router.push('kamiresultinput');
    }, 
    goto_print() {
			this.$router.push('kamisearchresultprint');
    }, 
    download_csv() {
      var daicho_list = this.$store.state.daicho;
      var csv = '\ufeff' + '確定,確認済,コメント,物件種別,取止め・取下げ等,確認申請番号,物件所在地,建築主住所,建築主氏名,主用途,構造,工事種別,地上階数,地下階数\n';
      daicho_list.forEach(function(item) {
        var line ='';
        line += '"'+this.$refs.listKamiResultRef.transform_flg_kakutei(item.flg_kakutei)+'"'; line += ',';
        line += '"'+this.$refs.listKamiResultRef.transform_done_kakutei(item.data_kknnzumi)+'"'; line += ',';
        line += '"'+this.$refs.listKamiResultRef.transform_annotation(item.annotation)+'"'; line += ',';
        line += '"'+this.$refs.listKamiResultRef.transform_bkn_sybt(item.bkn_sybt)+'"'; line += ',';
        line += '"'+this.$refs.listKamiResultRef.transform_stop_sybt(item.stop_sybt)+'"'; line += ',';
        line += '"'+this.$refs.listKamiResultRef.transform_bango(item)+'"'; line += ',';
        line += '"'+this.$refs.listKamiResultRef.transform_bkn_addr1(item.bkn_addr1)+'"'; line += ',';
        line += '"'+this.$refs.listKamiResultRef.transform_bldr_addr1(item.bldr_addr1)+'"'; line += ',';
        line += '"'+this.$refs.listKamiResultRef.transform_bldr_name1(item.bldr_name1)+'"'; line += ',';
        line += '"'+this.$refs.listKamiResultRef.transform_syuyo_yoto(item.gutai_syuyo_yoto)+'"'; line += ',';
        line += '"'+this.$refs.listKamiResultRef.transform_kozo_sybt(item.gutai_kozo_sybt)+'"'; line += ',';
        line += '"'+this.$refs.listKamiResultRef.transform_gutai_koji_sybt(item.gutai_koji_sybt)+'"'; line += ',';
        line += this.$refs.listKamiResultRef.transform_tijo_kaisu(item.tijo_kaisu); line += ',';
        line += this.$refs.listKamiResultRef.transform_tika_kaisu(item.tika_kaisu); line += ',';
        line += '\n';
        csv += line;
      }, this);
      let blob = new Blob([csv], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Result.csv'
      link.click()
    }, 
    plotKey(layerFeature) {
      const k = layerFeature.feature ?? layerFeature;
      let result = k.get(this.plotDef.key);
      if (this.plotDefAlt !== null) {
        //if (result === undefined || result === null || result.length === undefined || result.length == 0) {
        if (!result) {
          result = k.get(this.plotDefAlt.key);
        }
      }
      return result;
    },
    isSelectedRow(k) {
      //const layer = k.layer;
      const feature = k.feature;
      const no = this.plotKey(feature);
      //const selNo = this.selectedNo;
      const selNo = this.selectedId;
      const hit = (no == selNo)
      //console.log(`k:${no} sel:${selNo} hit:${hit}`)
      return hit;
    },
    plotLabel(k) {
      const layer = k.layer;
      const feature = k.feature;
      let result = '不明';
      if (layer == 'vectorLayer') {
        result = feature.get(this.plotDef.label);
        if (!result)
          result = feature.get(this.plotDef.key);
      }
      else if (layer == 'vectorLayerAlt') {
        result = feature.get(this.plotDefAlt.label);
        if (!result) {
          result = feature.get(this.plotDefAlt.key);
        }
      }
      return result ?? '';
    },
    
    // 呼び出される事がない？
    onMapSelectionChanged (selection) {
      //this.features = selection;
      //this.existsGaiyo = false;
      dbglog(`onMapSelectionChanged(${selection})`, -1);
      if (selection.length == 1) {
        dbglog(`MapPane: onMapSelectionChanged(${selection[0]})`, -1);
        this.selectRow(selection[0]);
      }
    },
    /**
     * プロット一覧から特定の行を選択状態にする
     * @param { PlotData } target 選択状態にするプロットデータ
     */
    selectRow (target) {
      //test
      //this.targetPlotData = target.feature;
      //
      this.selectedLayer = target.layer;
      const selNo = this.plotKey(target);
      let selLabel = this.plotLabel(target);
      // 開発・造成・土石の堆積、指定道路用にSEQをselectedIdに保存
      //this.selectedNo = selNo;
      this.selectedId = selNo;
      this.selectedNo = selLabel;
      //開発・造成・土石の堆積の別を判定
      /*
      if (selNo != selLabel) {
        this.$store.commit('setSearchTargetType', selLabel.includes('規') ? 1 : 0);
      }
      */
      this.$store.commit('setSearchTargetType', target.layer == 'vectorLayerAlt' ? 1 : 0);
      // 選択された番号の概要書データが存在するか調べて
      // 閲覧ボタンの使用可否を設定する（建築のみ）
      this.searchGaiyo(this.selectedNo, (data) => {
        this.existsGaiyo = (data && data.length);
      });
    },
    selectNendo (nendo) {
      dbglog(` selected: id=${nendo.id}, pageNo=${nendo.pageNo}, branch=${nendo.branch}`);
      this.$store.commit('setIndexId', nendo.id);
      this.$store.commit('setNendoName', nendo.name);
      //プロット地図画面の入力値をクリア
      this.$store.commit('setSearchYear', 0);
      this.$store.commit('setSearchBango', '');
      //
      this.$router.push({ name: 'plot-map', params: { sheet: nendo.pageNo } });
    },
    /**
     * 現在選択されているプロットの概要書を表示する
     */
    browse () {
      this.$store.commit('setUkeNo', this.selectedNo);
      this.$store.commit('setGaiyoId', this.selectedId);
      this.$router.push({ name: 'loading', params: { action: 1 }});
    },
    /**
     * 指定された受付番号のデータを検索する
     * （リスト選択時に閲覧ボタン使用可否を決定するために呼び出される）
     * @param {String} ukeNo 受付番号
     */
    searchGaiyo (ukeNo, callback) {
      if (ukeNo == null || ukeNo.length == 0) {
        this.existsGaiyo = false; //暫定措置
        return;
      }
      this.existsGaiyo = true; //暫定措置

      let url;
      if (this.mode == 1) {
        url = gaiyoURL() + '?uke_no=' + ukeNo;
      }
      else if (this.mode == 2) {
        //url = elvUrl() +  '?uke_no=' + ukeNo;
        return;
      }
      else {
        return;
      }
      dbglog(url);

      fetch(url, {
        mode: 'cors',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      })
      .then((response) => {
        dbglog(response);
        if (response.ok) {
          return response.json();
        }
        else {
          return response.status;
        }
      })
      .then((data) => {
        dbglog(data);
        if (data == 401) {
          this.loading = false;
          this.progressMessage = 'ユーザ認証に失敗しました。';
          this.authDialog = true;
          return;
        }
        callback(data);
      })
      .catch((err) => {
        dbglog(`MapPane.vue.searchGaiyo(${ukeNo}): ${err}`);
      });
    },
    onScroll(event) {
      //console.log(event.target.scrollTop);
      if(event.target.scrollTop == 200){
        //console.log('in');
        document.getElementsByClassName('v-dialog__content')[0].style.height = '90%';
        document.getElementsByClassName('v-dialog__content')[0].style.bottom = '0';
        document.getElementsByClassName('v-dialog__content')[0].style.top = 'revert';
      }else if(event.target.scrollTop == 0){
        document.getElementsByClassName('v-dialog__content')[0].style.height = '30%';
        document.getElementsByClassName('v-dialog__content')[0].style.bottom = '0';
        document.getElementsByClassName('v-dialog__content')[0].style.top = 'revert';
      }
    },
    touchUp(){
      if(document.querySelector('.v-bottom-sheet') != null){
        document.querySelector('.v-bottom-sheet').style.height = '90%';
      }
    },
    touchDown(){
      if(document.querySelector('.v-bottom-sheet') != null){
        document.querySelector('.v-bottom-sheet').style.height = '30%';
      }
    },
    
    searchMod(){
			//if(this.selectedData != null){
				for(let i = 0; i < document.getElementsByTagName('tbody')[0].children.length; i++){
					if(this.selectedData.daichoId == document.getElementsByTagName('tbody')[0].children[i].children[0].innerText){
						document.getElementsByTagName('tbody')[0].children[i].classList.add('light-blue');
						document.getElementsByTagName('tbody')[0].children[i].classList.add('lighten-4');
					}
				}
			//}
		},
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/common/common.css";
@import "../styles/split-alt.css";
body {
  background-color: #E0E0E0; /* グレーの背景色 */
  width: auto;
  height: auto;
}
thead {
  background-color: rgb(56, 110, 155);
  color: mintcream;
}
.split {
  //height: 100%;
  height: calc(100% - 12px);
  padding: 6px 0;
}
.right-box {
  right: 0;
  width: 30%;
  //height: 100%;
  height: calc(100% - 24px);
  margin: 4px 0;
  overflow-y: auto;
  background-color: rgb(118, 164, 170);
}
.acceptButton {
  font-size: 2rem;
  padding: 0.5em 1.5em;
}
/*
.selected {
  background-color: rgb(238, 255, 0);
}
*/
#selected-plot {
  background-color: lightsteelblue;
  font-size: 1.25rem;
  width: 100%;
  margin: 0.5em 0;
  text-align: center;
}

::v-deep .v-bottom-sheet {
  height: 30%;
}

.v-dialog__content {
  z-index:2 !important;
}

/* 操作部分 */
.button-container {
  display: flex;
  justify-content: center; /* 左右の中央揃え */
  align-items: center; /* 上下の中央揃え */
  background: linear-gradient(to bottom, #b0b0b0, #d1d1d1);
  padding:3px;
  padding-bottom:3px;
  padding-right:3px;
}

.action-button {
  position: relative;
  background: linear-gradient(to bottom, #d1d1d1, #b0b0b0);
  color: #000000;
  border: 1px solid #808080; /* ボーダーのスタイルと色 */
  padding: 10px 15px;
  margin-right: 1px; /* 仕切りとの間隔 */
  margin-bottom: 0px; /* 下部の余白を解除 */
  cursor: pointer;
}

.action-button::after {
  content: "";
  position: absolute;
  top: 0;
  right: -2px; /* 仕切りの太さ */
  height: 100%;
  width: 2px; /* 仕切りの幅 */
  background-color: #7a7a7a; /* 仕切りの色 */
}

.action-button:hover {
  background-color: #7c7c7c; /* カーソルが乗った時の背景色 */
}

.action-button[disabled] {
	background-color: #f0f0f0;
	color: #777;
	cursor: not-allowed;
}

.right-slide {
  margin-left: auto;
}

/* 表での出力が複雑なので仮でいれてあります */
.a4-box {
  width: 650px; /* 任意の小さな幅に変更 */
  height: 420px; /* 任意の小さな高さに変更 */
  border: 1px solid #000; /* ボーダーを追加（任意） */
  margin: 20px auto; /* 画面中央に配置（任意） */
}

/*タイトル*/
.pageTitle {
  margin: 0 auto; /* 左右の余白を自動的に調整して中央に配置 */
  text-align: center; /* 内部のテキストを中央揃え */
  font-size:32px;
}
.kensuu {
  margin: 0 auto; /* 左右の余白を自動的に調整して中央に配置 */
  text-align: center; /* 内部のテキストを中央揃え */
  font-size:16px;
}
</style>
